import { message } from "antd";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const getHistory = async (docId) => {
	try {
		const response = await client.get(`/docs/doc_history/${docId}`, {
			headers: authHeader(),
			params: { id: Number(docId) },
		});
		return response.data;
	} catch (error) {
		message.error("Произошла ошибка при загрузке истории изменения документа");
		console.error(error);
		return [];
	}
};

export default getHistory;
